import React, { useRef } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { sendTrainingAcknowledgement } from "actions/Support";
import { dateTimeFormatter } from "utilities";
import Tooltip from "components/Tooltip";
import ButtonContained from "components/ButtonContained";

const UserSettingsTrainingModal = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const sendTrainingButtonRef = useRef(null);
  const user = useSelector(state => state.users.userObject);
  const authUser = useSelector(state => state.auth.authUser);
  const site = useSelector(state => state.auth.site);
  const userTimezone = useSelector(state => state.app.userTimezone);

  const handleSendAcknowledgement = () => {
    dispatch(sendTrainingAcknowledgement(
      {
        userUUID: user.uuid,
        acknowledged: false
      },
      {
        successMessage: intl.formatMessage({ id: "notifications.success.sentTraining" })
      }
    ));
  }

  return (
    <div className="min-h-[300px] px-10 pt-4 flex flex-col justify-between">
      <div className="flex flex-col gap-4">
        <h5 className="tw-heading-5 mb-4">
          {intl.formatMessage({ id: "pages.users.trainingAcknowledgement" })}
        </h5>
        <div>
          <span className="tw-paragraph-reg font-semibold">{intl.formatMessage({ id: "form.status" })}: {" "}</span>
          <span className="tw-paragraph-reg">
            {user?.UserDigitalAcknowledgement?.acceptedDigitalAcknowledgement == ""
              ? intl.formatMessage({ id: `form.notSent` })
              : user?.UserDigitalAcknowledgement?.acceptedDigitalAcknowledgement == "false"
              ? intl.formatMessage({ id: `form.sentFalse` })
              : user?.UserDigitalAcknowledgement?.acceptedDigitalAcknowledgement == "true"
              ? intl.formatMessage({ id: `form.sentTrue` })
              : ""}
          </span>
        </div>
        <div>
          <span className="tw-paragraph-reg font-semibold">{intl.formatMessage({ id: "pages.users.supportUsername" })}: {" "}</span>
          <span className="tw-paragraph-reg">
            {user?.UserDigitalAcknowledgement?.supportUserName == ""
              ? intl.formatMessage({ id: `form.none` })
              : user?.UserDigitalAcknowledgement?.supportUserName}
          </span>
        </div>
        <div>
          <span className="tw-paragraph-reg font-semibold">{intl.formatMessage({ id: "form.lastUpdated" })}: {" "}</span>
          <span className="tw-paragraph-reg">
            {user?.UserDigitalAcknowledgement?.updated == "0001-01-01T00:00:00Z"
              ? intl.formatMessage({ id: `form.na` })
              : dateTimeFormatter(user?.UserDigitalAcknowledgement?.updated, authUser, site, userTimezone)}
          </span>
        </div>
      </div>
      <div>
        <ButtonContained
          ref={sendTrainingButtonRef}
          id="User-Settings-Send-Training-Button"
          dataCy="User-Settings-Send-Training-Button"
          text={intl.formatMessage({ id: "pages.users.sendTrainingAcknowledgement" })}
          type="medium"
          onClick={() => handleSendAcknowledgement()}
        />
      </div>
      <Tooltip
        anchorRef={sendTrainingButtonRef}
        text={intl.formatMessage({ id: "pages.users.sendAcknowledgementDescription" })}
      />
    </div>
  )
};

export default UserSettingsTrainingModal;